module.exports = __webpack_public_path__ + "img/hiking006.26dbad50.jpg";